import { render, staticRenderFns } from "./pointEventInfo.vue?vue&type=template&id=d0ab51b4&scoped=true&"
import script from "./pointEventInfo.vue?vue&type=script&lang=js&"
export * from "./pointEventInfo.vue?vue&type=script&lang=js&"
import style0 from "./pointEventInfo.vue?vue&type=style&index=0&id=d0ab51b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ab51b4",
  null
  
)

export default component.exports